import { render } from "./ProfileEditPersonal.vue?vue&type=template&id=78a55d81&ts=true"
import script from "./ProfileEditPersonal.vue?vue&type=script&lang=ts"
export * from "./ProfileEditPersonal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__